import { render } from "./ElementosGastosPage.vue?vue&type=template&id=a3773574&ts=true"
import script from "./ElementosGastosPage.vue?vue&type=script&lang=ts"
export * from "./ElementosGastosPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__